const state = () => ({
  id: '',
  name: '',
  cms: {},
  config: {},
  features: {},
  theme: {},
  visitor: {
    location: {}
  }
})

const getters = {
  feature: state => (name, value = true) => state.features[name] === undefined ? value : state.features[name]
}

const mutations = {
  setInstance (state, { config, cms, id, name, theme, features }) {
    state.config = config
    state.cms = cms
    state.id = id
    state.name = name
    state.theme = theme
    state.features = features || {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
